module.exports = __webpack_public_path__ + "static/media/語言所轉所作業要點_定稿.b36546ca.pdf";